import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

// Services
import { HeaderService } from 'src/app/services/header/header.service';
import { LoginService } from 'src/app/services/login/login.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-menu-mobile',
  templateUrl: './menu-mobile.component.html',
  styleUrls: ['./menu-mobile.component.sass']
})
export class MenuMobileComponent implements OnInit {

  show: boolean = false;

  logo: String = '';

  hasSession: boolean = false;

  listSubcriptions: Subscription[] = [];

  constructor(
    private _headerService: HeaderService,
    private _loginService: LoginService,
    private _sharedService: SharedService,
    private _router: Router,
  ) { }

  ngOnInit(): void {
    this.checkSession();
    this.getUrlLogo();
    this.listenerShowMenuMobile();
    this.listenerLoginSuccess();
  }

  ngOnDestroy(): void {
    this.listSubcriptions.forEach((sub: Subscription) => { if (sub) sub.unsubscribe(); });
  }

  getUrlLogo(): void {
    setTimeout( () => {
      if(localStorage.getItem('client_logo')) this.logo = localStorage.getItem('client_logo');
    }, 500);
  }

  closeMenu() {
    this._headerService.emmiterShowMenuMobile(false);
  }

  openLogin(): void {
    this.closeMenu();
    this._loginService.emmiterShowLogin(true);
  }

  goTo(route: String): void {
    this.closeMenu();
    this._router.navigate([`/${route}`]);
  }

  checkSession(): void {
    if(this._sharedService.validSession()){
      this.hasSession = true;
    } else this.hasSession = false;
  }

  listenerShowMenuMobile(): void {
    this.listSubcriptions.push(
      this._headerService.getSubjetShowMenuMobile().asObservable().subscribe(
        data => this.show = data
      )
    );
  }

  listenerLoginSuccess(): void {
    this.listSubcriptions.push(
      this._loginService.getSubjetLoginSuccess().asObservable().subscribe(
        data => {
          this.checkSession();
          this.hasSession = data;
        }
      )
    );
  }

}
